module.exports = __webpack_public_path__ + "static/media/thai.634dae38.png";